import EventEmitter from 'events';

export default class LogService extends EventEmitter {
  logs: string[] = [];

  addLog(log: string) {
    this.logs.push(log);
    this.emit('log', log);
  }
}
